var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{staticClass:"photo",attrs:{"src":_vm.props.image,"alt":_vm.props.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }